var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1I99IpkK2Whkso{display:flex;margin-top:8px;min-height:184px;border-radius:3px;background-color:#f4f5f7}._1I99IpkK2Whkso .RuhRi5TPHC1yQT{margin:16px 0 12px 16px;font-family:Helvetica Neue,Arial,Helvetica,sans-serif;font-size:14px;font-weight:400}._1I99IpkK2Whkso .RuhRi5TPHC1yQT .mVLtiSp-IlJMIK{font-weight:600;margin:0 0 8px}._1I99IpkK2Whkso .RuhRi5TPHC1yQT ul{line-height:175%;list-style:none;padding:0;margin:0}._1I99IpkK2Whkso .RuhRi5TPHC1yQT ._1VQJ8HVHsHaCav{margin-left:8px}._1I99IpkK2Whkso ._3id4Sla5a98s9j{background-image:url(" + escape(require("images/organization/out-of-free-team-boards.svg")) + ");background-repeat:no-repeat;min-width:120px;margin:12px 0 0 4px}._1I99IpkK2Whkso ._1cwZQeSK5Y8a_E{margin-top:16px}._1I99IpkK2Whkso ._1cwZQeSK5Y8a_E .MtCOtX5rmUNSvh{font-size:12px;color:#6b778c;text-decoration:none}._1I99IpkK2Whkso ._1cwZQeSK5Y8a_E .MtCOtX5rmUNSvh:hover{text-decoration:underline}", ""]);

// exports
exports.locals = {
	"ooftbContainer": "_1I99IpkK2Whkso",
	"ooftbText": "RuhRi5TPHC1yQT",
	"title": "mVLtiSp-IlJMIK",
	"liText": "_1VQJ8HVHsHaCav",
	"ooftbImage": "_3id4Sla5a98s9j",
	"feedbackLinkContainer": "_1cwZQeSK5Y8a_E",
	"feedbackLink": "MtCOtX5rmUNSvh"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/common/components/create-board/out-of-free-team-boards.less
// module id = odAW
// module chunks = 24